
let isPCMode_interactive_choose = null; // 用于记录当前模式，避免重复初始化
let cleanup_interactive_choose = null; // 用于保存清理函数（解绑事件等）

function initInteractive(isPC) {
    // 如果模式没变，直接返回
    if (isPCMode_interactive_choose === isPC) return;
    // 如果之前有初始化过，先清理
    if (cleanup_interactive_choose) {
        cleanup_interactive_choose();
        cleanup_interactive_choose = null;
    }

    isPCMode_interactive_choose = isPC;

    const prefix = isPC ? '#chosen_by_customer' : '#chosen_by_customer_mobile';

    const svgfonts = document.querySelectorAll(`${prefix} .second_section .second_item`);
    const fontsBtn = document.querySelectorAll(`${prefix} .second_section .second_item .font`);
    const itemList = document.querySelectorAll(`${prefix} .second_section .second_item`);
    const fourthList = document.querySelectorAll(`${prefix} .fourth_sction .fourth_sction_list`);

    // 边界检查：如果某个列表为空，说明 DOM 不存在，直接退出
    if (itemList.length === 0) {
        isPCMode_interactive_choose = null;
        return;
    }

    function toggleStatus(index) {
        svgfonts.forEach((item) => item.classList.remove('second_item_active'));
        fontsBtn.forEach((item) => item.classList.remove('font_active'));
        fourthList.forEach((item) => (item.style.display = 'none'));

        fourthList[index].style.display = 'flex';
        svgfonts[index].classList.add('second_item_active');
        fontsBtn[index].classList.add('font_active');
    }

    // 初始化第一个
    toggleStatus(0);

    // 绑定点击事件
    const handlers = [];
    itemList.forEach((item, index) => {
        const handler = () => toggleStatus(index);
        item.addEventListener('click', handler);
        handlers.push({ item, handler });
    });

    // 返回清理函数
    cleanup_interactive_choose = () => {
        handlers.forEach(({ item, handler }) => {
            item.removeEventListener('click', handler);
        });
    };
}

function checkAndInit() {
    const isPC = window.innerWidth >= 1024;
    initInteractive(isPC);
}

// 初次加载
checkAndInit();

// 监听窗口大小变化（防抖优化）
let resizeTimer_choose;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimer_choose);
    resizeTimer_choose = setTimeout(checkAndInit, 150); // 防抖 150ms
});

